import { useNavigate } from '@tanstack/react-router';
import { useCurrentUser } from '@/hook';
import { PageHeader, Tabs } from '@/component';
import { SettingsProfileTab } from './SettingsProfileTab';
import { PlanTab } from './Settings/PlanTab';
import { PurchasesTab } from './Settings/PurchasesTab';
import { TvsTab } from './Settings/TvsTab';

const TABS = [
  { value: 'profile', label: 'Profile' },
  { value: 'plan', label: 'Plan & billing' },
  { value: 'purchases', label: 'Purchases' },
  { value: 'tvs', label: 'Screens' },
] as const;

export type SettingsTab = (typeof TABS)[number]['value'];

export const isSettingsTab = (value: string): value is SettingsTab =>
  TABS.some((tab) => tab.value === value);

/** /settings/:tab? — the tab lives in the URL so plan CTAs can deep-link to it. */
export function SettingsPage({ tab: active }: { tab: SettingsTab }) {
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  return (
    <div>
      <PageHeader eyebrow={user?.handle ? `@${user.handle}` : 'Account'} title="Settings" />
      <Tabs
        tabs={TABS}
        value={active}
        onChange={(next) =>
          void navigate(next === 'profile' ? { to: '/settings' } : { to: '/settings/$tab', params: { tab: next } })
        }
        className="mt-10"
      />
      {active === 'profile' && user && <SettingsProfileTab key={user._id} user={user} />}
      {active === 'plan' && <PlanTab />}
      {active === 'purchases' && <PurchasesTab />}
      {active === 'tvs' && <TvsTab />}
    </div>
  );
}
